export class Lead {
	constructor() {
		this.init();
	}

	init() {
		this.forms = document.querySelectorAll("form.request-form__form");

		if (!this.forms.length) {
			console.error("Формы не найдены");
			return;
		}

		this.forms.forEach(form => this.setupForm(form));
	}

	setupForm(form) {
		const submitButtons = form.querySelectorAll("button[type='submit']");
		const consentCheckbox = form.querySelector(".checkbox input[type='checkbox']");

		if (!submitButtons.length || !consentCheckbox) {
			console.warn("Ошибка инициализации формы:", form);
			return;
		}

		// Блокировка кнопки при старте
		submitButtons.forEach(btn => btn.disabled = !consentCheckbox.checked);

		// Разблокировать по чекбоксу
		consentCheckbox.addEventListener("change", () => {
			const state = !consentCheckbox.checked;
			submitButtons.forEach(btn => btn.disabled = state);
		});

		// Обработка отправки формы
		form.addEventListener("submit", (event) => {
			event.preventDefault();
			this.sendZayav2(form, submitButtons, consentCheckbox);
		});
	}

	sendZayav2(form, submitButtons, consentCheckbox) {
		const el = $(form);

		if (!consentCheckbox.checked) {
			alert("Вы должны дать согласие на обработку персональных данных.");
			return false;
		}

		const name = el.find("input[name='str_name']").val().trim();
		const phone = el.find("input[name='str_phone']").val().trim();
		const mail = el.find("input[name='str_mail']").val().trim();
		const day = el.find("input[name='str_birthday']").val().trim();
		const diag = el.find("input[name='str_diag']").val().trim();
		const size = el.find("input[name='str_size']").val().trim();

		if (!name || !day || !size) {
			alert("Заполните все обязательные поля!");
			return false;
		}

		submitButtons.forEach(btn => btn.disabled = true);

		$.ajax({
			url: "/ajax.php?mid=7",
			type: "POST",
			data: {
				str_name: name,
				str_phone: phone,
				str_mail: mail,
				str_birthday: day,
				str_diag: diag,
				str_size: size,
				mode: "send_request"
			},
			dataType: "json",
			success: function (res) {
				if (typeof res === "string") {
					try {
						res = JSON.parse(res);
					} catch (e) {
						console.error("Ошибка парсинга JSON:", e, res);
						alert("Ошибка обработки ответа сервера.");
						return;
					}
				}

				console.log("Ответ сервера:", res);
				if (res.success) {
					el.trigger("reset");
					$(form).closest(".request-form__layout").find(".request-form__form, .request-form__title").hide();
					$(form).closest(".request-form__layout").find(".contacts-block-info-form-success").css("display", "flex");
				} else {
					alert("Ошибка: " + (res.message || "Неизвестная ошибка"));
				}
			},
			error: function (xhr, status, error) {
				console.error("Ошибка AJAX:", xhr, status, error);
				alert("Ошибка запроса: " + xhr.status + " - " + xhr.statusText);
			},
			complete: function () {
				submitButtons.forEach(btn => btn.disabled = false);
			}
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	if (!window.lead) {
		window.lead = new Lead();
	}
});